import { myApp } from '@white-label-plugin/global-app-context';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import type { CustomerGroupsConfig } from '@white-label-types/product-types';
import { type ProductType } from '@white-label-configuration/constants';

export type CustomerGroupLabels = {
  adult?: string,
  senior?: string,
  child?: string,
  infant?: string,
}

export const AGE_GROUP_ORDER: Record<keyof CustomerGroupLabels, number> = {
  adult: 0,
  senior: 1,
  child: 2,
  infant: 3,
};

export function getAgeGroupOrder(ageGroup?: keyof CustomerGroupLabels | null | undefined): number {
  if (!ageGroup) {
    return Number.MAX_SAFE_INTEGER;
  }

  return AGE_GROUP_ORDER[ageGroup] ?? Number.MAX_SAFE_INTEGER;
}

export function getCustomerGroupLabel(ageGroup: keyof CustomerGroupLabels | null | undefined, customerGroupLabels: CustomerGroupLabels): string {
  if (!ageGroup) {
    return '';
  }

  return customerGroupLabels[ageGroup] ?? '';
}


export function getProductTypeCustomerGroupLabels(productType: ProductType): CustomerGroupLabels {
  const customerGroups: CustomerGroupsConfig = getAppVariable(`products.${productType}.customer_groups`, {} as CustomerGroupsConfig) ?? {} as CustomerGroupsConfig;
  if (Object.keys(customerGroups).length === 0 || !myApp?.i18n?.tc) {
    return {};
  }
  let adult;
  let senior;
  let child;
  let infant;
  if (customerGroups.adult) {
    adult = `${myApp.i18n.tc('shared.customers.adult', 1)} ${customerGroups.adult.min_age}`;
    if (customerGroups.adult.max_age) {
      adult += ` - ${customerGroups.adult.max_age}`;
    } else {
      adult += '+';
    }
  }
  if (customerGroups?.senior) {
    senior = `${myApp.i18n.tc('shared.customers.senior', 1)} ${customerGroups.senior.min_age}+`;
  }
  if (customerGroups?.child) {
    child = `${myApp.i18n.tc('shared.customers.child', 1)} ${customerGroups.child.min_age} - ${customerGroups.child.max_age}`;
  }
  if (customerGroups?.infant) {
    infant = `${myApp.i18n.tc('shared.customers.infant', 1)} ${customerGroups.infant.min_age} - ${customerGroups.infant.max_age} ${myApp.i18n.tc('shared.customers.yearOld', customerGroups.infant.max_age)}`;
  }

  return {
    adult,
    senior,
    child,
    infant,
  };
}
